import styled from '@emotion/styled';

import { formatCurrency } from '../../../../../common/util/format';
import { PaySchedule } from '../../../enums';
import DataDisplayBlock from './DataDisplayBlock';

const PStyled = styled.p`
  font-size: 12px;
  font-weight: 400;
  display: inline;
`;

type VoeBreakdownProps = {
  result?: {
    calculatedMonthlyIncome?: number;
    calculatedTrendIncome?: number;
    incomeType?: string;
    trend?: string;
    calculationEquation?: string;
    incomeDetails?: {
      incomeYear?: string;
      monthlyIncome?: number;
      totalIncome?: number;
      fiscalYear?: number;
    }[];
  };
  payType: number;
  ytdMonthlyAverageEquation: number | string;
  currentGrossBasePay: number;
};

const VoeBreakdown = ({
  result,
  payType,
  ytdMonthlyAverageEquation,
  currentGrossBasePay,
}: Readonly<VoeBreakdownProps>) => {
  const payFreq = Object.keys(PaySchedule).find(
    (freq) => (PaySchedule as Record<string, number>)[freq] === payType,
  );

  const nonVariableIncome =
    payType !== PaySchedule['Variable Hourly'] && result;

  const DisplayBlocks: React.ComponentProps<typeof DataDisplayBlock>[] = [
    {
      containerProps: { mb: '20px' },
      header: 'Monthly Income Calculation:',
      dlProps: { fontSize: 'sm' },
      data: [
        { label: 'Pay Frequency', value: payFreq },
        { label: 'Rate', value: formatCurrency(currentGrossBasePay) },
      ],
    },
  ];
  if (nonVariableIncome) {
    DisplayBlocks.push({
      containerProps: {
        mt: '20px',
        ml: '-8px',
        pb: '20px',
        pt: '20px',
        pl: '24px',
        bgColor: 'bgGray.200',
      },
      header: (
        <>
          Base Income Calculation <PStyled>(Applied to monthly income)</PStyled>
        </>
      ),
      dlProps: { fontSize: 'sm' },
      data: [
        { label: 'Calculation', value: result.calculationEquation },
        {
          label: 'Calculated Base Income',
          value: formatCurrency(result.calculatedMonthlyIncome),
        },
      ],
    });
    DisplayBlocks.push({
      containerProps: {
        mb: '20px',
        pt: '20px',
      },
      header: 'Year-to-date Income Calculation',
      dlProps: { fontSize: 'sm' },
      data: [
        { label: 'Calculation', value: String(ytdMonthlyAverageEquation) },
        {
          label: 'Calculated Monthly Income',
          value: formatCurrency(result.incomeDetails[0].monthlyIncome),
        },
      ],
    });
  }
  return (
    <>
      {DisplayBlocks.map((block) => (
        <DataDisplayBlock key={block.data.at(-1)?.label} {...block} />
      ))}
    </>
  );
};

export default VoeBreakdown;
